import { render } from "./AddMetaTable.vue?vue&type=template&id=62840830&scoped=true"
import script from "./AddMetaTable.vue?vue&type=script&lang=js"
export * from "./AddMetaTable.vue?vue&type=script&lang=js"

import "./AddMetaTable.vue?vue&type=style&index=0&id=62840830&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62840830"]])

export default __exports__